// src/infrastructure/mapbox/adapters/geoJsonAdapter.ts
// Convert domain data to GeoJSON for mapbox
// map/adapters are render helpers, not domain infrastructure.

import { MapMarker } from '../../domain/entities/MapMarker';

export function mapMarkersToGeoJson(
  markers: MapMarker[]
): GeoJSON.FeatureCollection {
  return {
    type: 'FeatureCollection',
    features: markers.map((marker) => ({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [marker?.lng, marker?.lat],
      },
      properties: {
        id: marker.propertyId,
        listPrice: marker?.listPrice,
        saleOrRent: marker?.saleOrRent,
        latitude: marker.lat,
        longitude: marker.lng,
      },
    })) as GeoJSON.Feature[],
  };
}
